// extracted by mini-css-extract-plugin
export default {"add-dapp-top-bar":"AddDappTopBar_add-dapp-top-bar__BFb5e","special-tooltip":"AddDappTopBar_special-tooltip__oal80","shadow-flicker":"AddDappTopBar_shadow-flicker__B12H+"};